import React from 'react';
import './JobForm.css';

const JobForm = ({ jobDetails, handleChange, handleSaveJob, editingJobId, onCancel }) => {
  return (
    <form className="adminjob-form">
      <div className="adminjob-form-row">
        <div className="adminjob-form-group">
          <label>Job Title</label>
          <input type="text" name="title" value={jobDetails.title} onChange={handleChange} />
        </div>
        <div className="adminjob-form-group">
          <label>Company</label>
          <input type="text" name="company" value={jobDetails.company} onChange={handleChange} />
        </div>
      </div>

      <div className="adminjob-form-row">
        <div className="adminjob-form-group">
          <label>Job Type</label>
          <select name="jobType" value={jobDetails.jobType} onChange={handleChange}>
            <option value="">Select</option>
            <option value="Full-Time">Full-Time</option>
            <option value="Part-Time">Part-Time</option>
            <option value="Contract">Contract</option>
          </select>
        </div>
        <div className="adminjob-form-group">
          <label>Experience (years)</label>
          <select name="experience" value={jobDetails.experience} onChange={handleChange}>
            <option value="">Select</option>
            {[...Array(20).keys()].map(i => (
              <option key={i} value={i + 1}>{i + 1} years</option>
            ))}
          </select>
        </div>
      </div>

      <div className="adminjob-form-row">
        <div className="adminjob-form-group">
          <label>Location</label>
          <input type="text" name="location" value={jobDetails.location} onChange={handleChange} />
        </div>
        <div className="adminjob-form-group">
          <label>Industry</label>
          <select name="industry" value={jobDetails.industry} onChange={handleChange}>
            <option value="">Select</option>
            <option value="IT">IT</option>
            <option value="Sales">Sales</option>
            <option value="Marketing">Marketing</option>
          </select>
        </div>
      </div>

      <div className="adminjob-form-group full-width">
        <label>Skills (comma separated)</label>
        <input type="text" name="skills" value={jobDetails.skills} onChange={handleChange} />
      </div>

      <div className="adminjob-form-group full-width">
        <label>Logo URL</label>
        <input type="text" name="logo" value={jobDetails.logo} onChange={handleChange} />
      </div>

      <div className="adminjob-form-group full-width">
        <label>Short Description</label>
        <textarea name="shortdesc" value={jobDetails.shortdesc} onChange={handleChange} />
      </div>

      <div className="adminjob-form-group full-width">
        <label>Description</label>
        <textarea name="description" value={jobDetails.description} onChange={handleChange} />
      </div>

      <div className="adminjob-form-actions">
        <button type="button" onClick={onCancel}>Cancel</button>
        <button type="button" onClick={handleSaveJob}>
          {editingJobId ? 'Update Job' : 'Add Job'}
        </button>
      </div>
    </form>
  );
};

export default JobForm;
